export default "__VITE_ASSET__DsY1ZIrL__"